import React from 'react';
// import { Button } from '../Buttons/button';
import { useNavigate } from 'react-router-dom';
// import './style.css'

export function Error() {
    // const navigate = useNavigate()
    return (
        <div className='m-5 p-5 f-raleway-m'>
            К сожалению оплата не прошла

            {/* <div className='w-25'>
                <Button text='На главную' handleClick={()=>navigate('/', {replace: true})}/> 
            </div> */}
        </div>
    )
}